import React, { useRef } from 'react';
import { translate } from 'react-i18next';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { formatDate, formatDateTime, getStyle, getVehicleBusinessUnitName, SERVICE_FLEET, SERVICE_WORKSHOP, styleMerge, truncateString, TYPE_CARE_SERVICE, TYPE_CHAIN_CARE_SERVICE, TYPE_ORGANIZATION_GARAGE, TYPE_WORKSHOP_ALL } from '../../../utils/utils';
import OptionsButton from '../../GarageView/GarageViewComponents/OptionsComponents/OptionsButton';
import EditVehicleTopInfoModal from '../../VehicleDetailsView/VehicleDetailsComponents/Modal/EditVehicleTopInfoModal';
import CBPromptModal from '../../shared/CBPromptModal';
import { withRouter } from 'react-router';
import AttachVehicleModal from './AttachVehicleModal';
import VehicleListTd from './VehicleListTd';
import CBMobileCard from '../../shared/CBMobileCard';
import CBCheckbox from '../../shared/form_components/CBCheckbox';
import CBLabelAndCheckbox from '../../shared/CBLabelAndCheckbox';
import SelectCheckListItemsModal from './SelectCheckListItemsModal';
import SaleReportModal from './SaleReportModal';
import ManualKmModal from './ManualKmModal';
import AddMileageModal from '../../VehicleDetailsView/VehicleDetailsComponents/Modal/AddMileageModal';
import ChangeGarageModal from '../../GarageView/GarageViewComponents/ChangeGarageModal';
import { Tooltip } from 'primereact/tooltip';

class VehicleListItem extends React.Component {
  state = {
    editModalIsOpen: false,
    deleteModalIsOpen: false,
    attachModalIsOpen: false,
    endCareServiceModalIsOpen: false,
    checkListModalIsOpen: false,
    saleReportModalIsOpen: false,
    manualKmModalIsOpen: false,
    changeGarageModalIsOpen: false,
    assignWorkshopModalIsOpen: false,
    selectedWorkshopId: '',
  }

  constructor(props) {
    super(props);
    this.settingsMenu = React.createRef();
  }

  componentDidMount() {
  }

  closeModal = () => {
    this.setState({
      editModalIsOpen: false,
    });
  };

  closeDeletePromptModal = () => {
    this.setState({
      deleteModalIsOpen: false,
    });
  };

  closeManualKmModal = () => {
    this.setState({
      manualKmModalIsOpen: false,
    });
  };

  closeCheckListModal = () => {
    const {
      refetchVehicles,
    } = this.props;

    this.setState({
      checkListModalIsOpen: false,
    });
    refetchVehicles();
  };

  closeAttachModal = () => {
    this.setState({
      attachModalIsOpen: false,
    });
  };

  closeSaleReportModal = () => {
    this.setState({
      saleReportModalIsOpen: false,
    });
  };

  closeEndCareServiceModal = () => {
    this.setState({
      endCareServiceModalIsOpen: false,
    });
  };

  checkBoxChanged = () => {
    const {
      selected,
      select,
      unselect,
      vehicle,
    } = this.props;

    if (selected) {
      unselect(vehicle.id);
    } else {
      select(vehicle.id);
    }
  };

  getUrlPrefix = () => {
    const { listType } = this.props;
    if (listType === TYPE_WORKSHOP_ALL) return 'workshop-vehicle';
    return 'vehicle';
  };

  getVehicleOptions = (vehicle) => {
    const { service, listType, isAllOrganizationsView, organization, user, t } = this.props;

    const urlPrefix = this.getUrlPrefix();

    const isOrganizationEmployee = (service === SERVICE_FLEET && organization && organization.user_role === 'employee');

    const options = [
      {
        label: t('open', { ns: 'common' }),
        icon: 'pi pi-info',
        url: `/${urlPrefix}/${vehicle.id}/`,
      },
    ];

    if (listType !== TYPE_WORKSHOP_ALL) {
      options.push({
        label: t('editInfo', { ns: 'GarageView' }),
        icon: 'pi pi-pencil',
        command: () => {
          this.setState({
            editModalIsOpen: true,
          });
        },
      });
    }

    if (listType === TYPE_ORGANIZATION_GARAGE && !isOrganizationEmployee) {
      options.push({
        label: t('attachToVehicle', { ns: 'GarageView' }),
        icon: 'pi pi-car',
        command: () => {
          this.setState({
            attachModalIsOpen: true,
          });
        },
      });
    }

    if (listType === TYPE_ORGANIZATION_GARAGE && service === SERVICE_FLEET && !isAllOrganizationsView && !isOrganizationEmployee) {
      options.push({
        label: t('changeGarage', { ns: 'GarageView' }),
        icon: 'pi pi-building',
        command: () => {
          this.setState({
            changeGarageModalIsOpen: true,
          });
        },
      });
    }

    if ((listType === TYPE_ORGANIZATION_GARAGE && service === SERVICE_FLEET) || (listType === TYPE_CARE_SERVICE && service === SERVICE_WORKSHOP)) {
      options.push({
        label: t('setOdometerReading', { ns: 'GarageView' }),
        icon: 'pi pi-chart-pie',
        command: () => {
          this.setState({
            manualKmModalIsOpen: true,
          });
        },
      });
    }

    if ((service === SERVICE_FLEET && !isOrganizationEmployee) || (service === SERVICE_WORKSHOP && listType !== TYPE_WORKSHOP_ALL)) {
      options.push({
        label: t('inspectionItems', { ns: 'GarageView' }),
        icon: 'pi pi-calendar',
        command: () => {
          this.setState({
            checkListModalIsOpen: true,
          });
        },
      });
    }

    if (vehicle.care_service_workshop_name && !isOrganizationEmployee) {
      options.push({
        label: t('endCareService', { ns: 'GarageView' }),
        icon: 'pi pi-trash',
        command: () => {
          this.setState({
            endCareServiceModalIsOpen: true,
          });
        },
      });
    }

    // The fleet portal has no assign action here (it never passed one, so the
    // item silently did nothing); its vastuukorjaamo lives on the settings page.
    if (vehicle.chain_care_service_info && !isOrganizationEmployee && this.props.assignWorkshopToVehicle) {
      options.push({
        label: t('csSetWorkshop', { ns: 'ChainSettingsView' }),
        icon: 'pi pi-wrench',
        command: () => {
          var info = vehicle.chain_care_service_info;
          this.setState({
            assignWorkshopModalIsOpen: true,
            selectedWorkshopId: info && info.assigned_workshop_id ? String(info.assigned_workshop_id) : '',
          });
        },
      });
    }

    if (service === SERVICE_FLEET && vehicle.can_delete) {
      options.push({
        label: t('delete', { ns: 'common' }),
        icon: 'pi pi-trash',
        command: () => {
          this.setState({
            deleteModalIsOpen: true,
          });
        },
      });
    }

    return options;
  };

  navigateToVehicle = (vehicleId) => {
    const { history, vehicle } = this.props;
    const urlPrefix = this.getUrlPrefix();
    history.push(`/${urlPrefix}/${vehicle.id}/`);
  };

  navigateToVehicleMessages = (vehicleId) => {
    const { history, vehicle } = this.props;
    const urlPrefix = this.getUrlPrefix();
    history.push(`/${urlPrefix}/${vehicle.id}/messages`);
  };

  getCardFaceFields = () => {
    const { vehicle, t } = this.props;
    var nsv = { ns: 'VehicleListView' };
    var fields = [];
    if (vehicle.organization || vehicle.garage) {
      fields.push({ label: t('headingCompanyAndGarage', nsv), value: [vehicle.organization, vehicle.garage].filter(Boolean).join(' / ') });
    }
    if (vehicle.care_service_workshop_name) {
      fields.push({ label: t('headingWorkshopName', nsv), value: vehicle.care_service_workshop_name });
    }
    if (vehicle.inspection_interval_end) {
      fields.push({ label: t('headingNextInspectionDate', nsv), value: formatDate(vehicle.inspection_interval_end) });
    }
    if (vehicle.last_maintenance_date) {
      fields.push({
        label: t('headingLastMaintenanceDate', nsv),
        value: formatDate(vehicle.last_maintenance_date) + (vehicle.last_maintenance_km ? (' · ' + vehicle.last_maintenance_km + ' km') : ''),
      });
    }
    return fields;
  };

  getCardAllFields = () => {
    const { vehicle, t, listType, useVehicleIdentifier } = this.props;
    var nsv = { ns: 'VehicleListView' };
    var fields = [];
    fields.push({
      label: t('headingRegistrationNumber', nsv),
      value: [vehicle.registration_number, [vehicle.manufacturer, vehicle.model_name].filter(Boolean).join(' ')].filter(Boolean).join(' · ') || '-',
    });
    if (useVehicleIdentifier && vehicle.organization_data && vehicle.organization_data.identifier) {
      fields.push({ label: t('headingVehicleIdentifier', nsv), value: vehicle.organization_data.identifier });
    }
    fields.push({ label: t('headingVehicleClass', nsv), value: vehicle.vehicle_class || '-' });
    if (listType !== TYPE_WORKSHOP_ALL) {
      fields.push({ label: t('headingCompanyAndGarage', nsv), value: [vehicle.organization, vehicle.garage].filter(Boolean).join(' / ') || '-' });
      fields.push({ label: t('headingWorkshopName', nsv), value: [vehicle.care_service_workshop_name, vehicle.chain_care_service_info ? vehicle.chain_care_service_info.chain_name : null].filter(Boolean).join(' · ') || '-' });
      var emp = [
        vehicle.organization_vehicle_status ? vehicle.organization_vehicle_status.employee : null,
        getVehicleBusinessUnitName(vehicle),
      ].filter(Boolean).join(' / ');
      fields.push({ label: t('headingEmployee', nsv), value: emp || '-' });
      fields.push({ label: t('headingUnreadMessageCount', nsv), value: ('unread_message_count' in vehicle) ? String(vehicle.unread_message_count) : '-' });
      fields.push({ label: t('headingAttachedVehicles', nsv), value: (vehicle.children && vehicle.children.length) ? vehicle.children.map(function (c) { return c.registration_number; }).join(', ') : '-' });
    }
    if (listType === TYPE_WORKSHOP_ALL) {
      fields.push({ label: t('headingWorkshopLastMaintenanceDate', nsv), value: vehicle.workshop_last_maintenance_date ? (formatDate(vehicle.workshop_last_maintenance_date) + (vehicle.workshop_last_maintenance_km ? (' · ' + vehicle.workshop_last_maintenance_km + ' km') : '')) : '-' });
    }
    fields.push({ label: t('headingLastMaintenanceDate', nsv), value: vehicle.last_maintenance_date ? (formatDate(vehicle.last_maintenance_date) + (vehicle.last_maintenance_km ? (' · ' + vehicle.last_maintenance_km + ' km') : '')) : '-' });
    fields.push({ label: t('headingMaintenanceCount', nsv), value: vehicle.maintenance_count != null ? String(vehicle.maintenance_count) : '-' });
    fields.push({ label: t('headingNextInspectionDate', nsv), value: vehicle.inspection_interval_end ? formatDate(vehicle.inspection_interval_end) : '-' });
    if (listType !== TYPE_WORKSHOP_ALL) {
      fields.push({ label: t('headingNextCheckDate', nsv), value: (vehicle.next_check && vehicle.next_check.date) ? (formatDate(vehicle.next_check.date) + (vehicle.next_check.name ? (' · ' + vehicle.next_check.name) : '')) : '-' });
    }
    fields.push({ label: t('headingTraficomSyncDate', nsv), value: vehicle.traficom_sync_date ? formatDate(vehicle.traficom_sync_date) : '-' });
    return fields;
  };

  renderMobileCard = () => {
    const { vehicle, selected, garage } = this.props;
    const { editModalIsOpen, attachModalIsOpen } = this.state;
    var badges = [];
    if (vehicle.unread_message_count > 0) {
      badges.push(
        <span key='unread' style={mobileBadgeStyles.pill}>
          <img src='/img/icon_11.svg' alt='' style={{ height: 12, marginRight: 4, verticalAlign: 'middle' }} />
          {vehicle.unread_message_count}
        </span>
      );
    }
    return (
      <React.Fragment>
        <CBMobileCard
          title={vehicle.registration_number}
          dialogTitle={vehicle.registration_number}
          subtitle={truncateString([vehicle.manufacturer, vehicle.model_name].join(' '), 35)}
          selected={selected}
          onSelectChange={this.checkBoxChanged}
          badges={badges}
          fields={this.getCardFaceFields()}
          allFields={this.getCardAllFields()}
          options={this.getVehicleOptions(vehicle)}
          onClick={() => this.navigateToVehicle(vehicle.id)}
        />
        {editModalIsOpen && (
          <EditVehicleTopInfoModal
            modalIsOpen={editModalIsOpen}
            closeModal={this.closeModal}
            vehicle={vehicle}
            isOrganizationVehicle={!!vehicle.organization_id}
          />
        )}
        {attachModalIsOpen && (
          <AttachVehicleModal
            modalIsOpen={attachModalIsOpen}
            closeModal={this.closeAttachModal}
            vehicle={vehicle}
            garage={garage}
          />
        )}
      </React.Fragment>
    );
  };

  render() {
    const {
      vehicle,
      t,
      selectedFields,
      garage,
      removeVehicleFromGarage,
      selected,
      endCareService,
      refetchVehicles,
      listType,
      hasFeatureVehicleReports,
      hasFeatureTasksAndMessages,
      hasFeatureVehicleReportsPdf,
      useVehicleIdentifier
    } = this.props;
    const {
      editModalIsOpen,
      deleteModalIsOpen,
      attachModalIsOpen,
      endCareServiceModalIsOpen,
      checkListModalIsOpen,
      saleReportModalIsOpen,
      manualKmModalIsOpen,
      changeGarageModalIsOpen
    } = this.state;

    const imageUrl = vehicle.image ? vehicle.image.image : 'none';

    const imageStyle = {
      backgroundImage: `url("${imageUrl}")`,
    };

    return (
      <CBMediaQuery>
        {screenSize => (
          <React.Fragment>
            {screenSize === 'small' ? (
              this.renderMobileCard()
            ) : (
            <tr style={getStyle(screenSize, styles, 'vehicleRow')}>
              <td style={getStyle(screenSize, styles, 'tableRegNumTd')}>
                <CBLabelAndCheckbox
                  additionalStyles={{ justifyContent: 'center' }}
                  checked={selected}
                  onChange={this.checkBoxChanged}
                />
              </td>
              {
                selectedFields.includes('image') && listType != TYPE_WORKSHOP_ALL && (
                  <td onClick={this.navigateToVehicle} style={getStyle(screenSize, styles, 'vehicleImageColumn')}>
                    <div style={styleMerge(getStyle(screenSize, styles, 'imgPlaceholder'), imageStyle)}></div>
                  </td>
                )
              }

              {
                selectedFields.includes('identifier') && useVehicleIdentifier && (
                  <VehicleListTd
                    onClick={this.navigateToVehicle}
                    textPrimary={vehicle.organization_data ? vehicle.organization_data.identifier : ''}
                    additionalStylesPrimaryText={{ fontSize: 24 }}
                  />
                )
              }

              <VehicleListTd
                onClick={this.navigateToVehicle}
                textPrimary={vehicle.registration_number}
                textSecondary={truncateString([vehicle.manufacturer, vehicle.model_name].join(' '), 35)}
                additionalStylesPrimaryText={{ fontSize: 24 }}
              />
              {
                selectedFields.includes('vehicle_class') && (
                  <VehicleListTd
                    onClick={this.navigateToVehicle}
                    textPrimary={vehicle.vehicle_class ? vehicle.vehicle_class : ''}
                  />
                )
              }
              {
                selectedFields.includes('organization') && listType != TYPE_WORKSHOP_ALL && (
                  <VehicleListTd
                    onClick={this.navigateToVehicle}
                    textPrimary={vehicle.organization}
                    textSecondary={vehicle.garage}
                  />
                )
              }
              {
                selectedFields.includes('care_service_workshop_name') && listType != TYPE_WORKSHOP_ALL && (
                  <VehicleListTd
                    onClick={this.navigateToVehicle}
                    textPrimary={vehicle.care_service_workshop_name}
                    textSecondary={vehicle.chain_care_service_info ? vehicle.chain_care_service_info.chain_name : null}
                  />
                )
              }
              {
                selectedFields.includes('employee') && listType != TYPE_WORKSHOP_ALL && (
                  <VehicleListTd
                    onClick={this.navigateToVehicle}
                    textPrimary={vehicle.organization_vehicle_status && vehicle.organization_vehicle_status.employee}
                    textSecondary={getVehicleBusinessUnitName(vehicle)}
                  />
                )
              }
              {
                selectedFields.includes('unread_message_count') && listType != TYPE_WORKSHOP_ALL && (hasFeatureTasksAndMessages || listType == TYPE_CARE_SERVICE) && (
                  <td onClick={this.navigateToVehicleMessages} style={styleMerge(getStyle(screenSize, styles, 'tableValueTd'), getStyle(screenSize, styles, 'alignCenter'))}>
                    {
                      'unread_message_count' in vehicle && (
                        vehicle.unread_message_count > 0
                          ? <img src='/img/icon_11.svg' alt={t('newMessages', { ns: 'GarageView' })} style={getStyle(screenSize, styles, 'infoIcon')} />
                          : t('no', { ns: 'common' })
                      )
                    }
                  </td>
                )
              }
              {
                selectedFields.includes('attached_vehicles') && listType != TYPE_WORKSHOP_ALL && (
                  <VehicleListTd
                    onClick={this.navigateToVehicle}
                    textPrimary={vehicle.children && vehicle.children.map((child) => child.registration_number).join(', ')}
                    additionalStyles={getStyle(screenSize, styles, 'alignCenter')}
                  />
                )
              }

              {
                selectedFields.includes('workshop_last_maintenance_date') && listType == TYPE_WORKSHOP_ALL && (
                  <VehicleListTd
                    onClick={this.navigateToVehicle}
                    textPrimary={formatDate(vehicle.workshop_last_maintenance_date)}
                    textSecondary={vehicle.workshop_last_maintenance_km ? `${vehicle.workshop_last_maintenance_km} km` : ''}
                  />
                )
              }

              {
                selectedFields.includes('last_maintenance_date') && (
                  <VehicleListTd
                    onClick={this.navigateToVehicle}
                    textPrimary={formatDate(vehicle.last_maintenance_date)}
                    textSecondary={vehicle.last_maintenance_km ? `${vehicle.last_maintenance_km} km` : ''}
                  />
                )
              }
              {
                selectedFields.includes('maintenance_count') && (
                  <VehicleListTd
                    onClick={this.navigateToVehicle}
                    textPrimary={vehicle.maintenance_count != null ? vehicle.maintenance_count : ''}
                  />
                )
              }
              {
                selectedFields.includes('inspection_interval_end') && (
                  <VehicleListTd
                    onClick={this.navigateToVehicle}
                    textPrimary={vehicle.inspection_interval_end && formatDate(vehicle.inspection_interval_end)}
                    textSecondary={vehicle.last_inspection_date && formatDate(vehicle.last_inspection_date)}
                  />
                )
              }
              {
                selectedFields.includes('next_check_date') && listType != TYPE_WORKSHOP_ALL && (
                  <React.Fragment>
                    {
                      vehicle.next_check && vehicle.next_check.edited_by && vehicle.next_check.edited_at && (
                        <Tooltip target={`#next-check-${vehicle.id}`} content={`${vehicle.next_check.edited_by} ${formatDateTime(vehicle.next_check.edited_at)}`} showDelay={1000} hideDelay={100} position='mouse' />
                      )
                    }
                    <VehicleListTd
                      id={`next-check-${vehicle.id}`}
                      onClick={this.navigateToVehicle}
                      textPrimary={vehicle.next_check && formatDate(vehicle.next_check.date)}
                      textSecondary={vehicle.next_check && vehicle.next_check.name}
                    />
                  </React.Fragment>
                )
              }
              {
                selectedFields.includes('get_sale_report') && listType == TYPE_ORGANIZATION_GARAGE && hasFeatureVehicleReports && (
                  <td onClick={(e) => {e.stopPropagation();this.setState({saleReportModalIsOpen: true})}} style={styleMerge(getStyle(screenSize, styles, 'tableValueTd'), getStyle(screenSize, styles, 'alignCenter'))}>
                    {
                      vehicle.has_sale_report
                        ? (
                            <img
                              className='opacity-on-hover'
                              src='/img/icon_vehicle_report.svg'
                              alt='Hae myyntiraportti'
                              style={getStyle(screenSize, styles, 'infoIcon')}
                            />
                          )
                        : (
                            <img
                              className='opacity-on-hover'
                              src='/img/icon_vehicle_report.svg'
                              alt='Hae myyntiraportti'
                              style={styleMerge(getStyle(screenSize, styles, 'infoIcon'), {opacity: 0.4})}
                            />
                          )
                    }
                  </td>
                )
              }
              {
                selectedFields.includes('traficom_sync_date') && (
                  <td onClick={this.navigateToVehicle} style={getStyle(screenSize, styles, 'tableValueTd')}>
                    {vehicle.traficom_sync_date && formatDate(vehicle.traficom_sync_date)}
                  </td>
                )
              }

              <td style={getStyle(screenSize, styles, 'tableOptionsTd')}>
                <Menu model={this.getVehicleOptions(vehicle)} popup ref={this.settingsMenu} />
                <div
                  style={getStyle(screenSize, styles, 'container')}
                  onClick={(e) => {this.settingsMenu.current.toggle(e)}}
                >
                  <img
                    alt='Options'
                    className="opacity-and-border-on-hover"
                    style={getStyle(screenSize, styles, 'optionsIcon')}
                    src='/img/icon_options.svg'
                  />
                </div>
                {
                  editModalIsOpen && (
                    <EditVehicleTopInfoModal
                      modalIsOpen={editModalIsOpen}
                      closeModal={this.closeModal}
                      vehicle={vehicle}
                      isOrganizationVehicle={!!vehicle.organization_id}
                    />
                  )
                }
                {
                  attachModalIsOpen && (
                    <AttachVehicleModal
                      modalIsOpen={attachModalIsOpen}
                      closeModal={this.closeAttachModal}
                      vehicle={vehicle}
                      garage={garage}
                    />
                  )
                }
              </td>
            </tr>
            )}
            <CBPromptModal
              modalIsOpen={deleteModalIsOpen}
              closeModal={this.closeDeletePromptModal}
              afterOpenModal={() => {}}
              title={t('deleteFromGaragePromptTitle')}
              text={t('deleteFromGaragePromptText')}
              buttonText={t('deleteFromGaragePromptButton')}
              performAction={() => removeVehicleFromGarage(vehicle.id, vehicle.garage_id)}
            />

            <CBPromptModal
              modalIsOpen={endCareServiceModalIsOpen}
              closeModal={this.closeEndCareServiceModal}
              afterOpenModal={() => {}}
              title={t('endCareServiceTitle')}
              text={t('endCareServiceText')}
              buttonText={t('endCareServiceButton')}
              performAction={() => {
                endCareService(vehicle);
                this.closeEndCareServiceModal();
              }}
            />

            {
              saleReportModalIsOpen && (
                <SaleReportModal
                  modalIsOpen={saleReportModalIsOpen}
                  closeModal={this.closeSaleReportModal}
                  afterOpenModal={() => {}}
                  t={t}
                  vehicle={vehicle}
                  hasFeatureVehicleReportsPdf={hasFeatureVehicleReportsPdf}
                />
              )
            }

            {
              manualKmModalIsOpen && (
                <AddMileageModal
                  modalIsOpen={manualKmModalIsOpen}
                  closeModal={this.closeManualKmModal}
                  afterOpenModal={() => {}}
                  t={t}
                  vehicle={vehicle}
                />
              )
            }

            {
              checkListModalIsOpen && (
                <SelectCheckListItemsModal
                  modalIsOpen={checkListModalIsOpen}
                  closeModal={this.closeCheckListModal}
                  afterOpenModal={() => {}}
                  vehicle={vehicle}
                />
              )
            }

            {
              changeGarageModalIsOpen && (
                <ChangeGarageModal
                  modalIsOpen={changeGarageModalIsOpen}
                  closeModal={() => this.setState({changeGarageModalIsOpen: false})}
                  afterOpenModal={() => {}}
                  vehicle={vehicle}
                />
              )
            }

            {
              this.state.assignWorkshopModalIsOpen && vehicle.chain_care_service_info && (
                <CBPromptModal
                  modalIsOpen={this.state.assignWorkshopModalIsOpen}
                  closeModal={() => this.setState({ assignWorkshopModalIsOpen: false, selectedWorkshopId: '' })}
                  afterOpenModal={() => {}}
                  title={t('csSetWorkshop', { ns: 'ChainSettingsView' })}
                  text={vehicle.registration_number}
                  buttonText={t('save', { ns: 'common' })}
                  performAction={() => {
                    if (this.props.assignWorkshopToVehicle) {
                      var targetWsId;
                      if (this.props.service === SERVICE_WORKSHOP) {
                        // Service portal: always the current workshop.
                        targetWsId = this.props.currentWorkshopId || null;
                      } else {
                        var wsId = this.state.selectedWorkshopId;
                        targetWsId = wsId === '' ? null : wsId;
                      }
                      this.props.assignWorkshopToVehicle(
                        vehicle.chain_care_service_info.chain_care_service_vehicle_id,
                        targetWsId
                      );
                    }
                    this.setState({ assignWorkshopModalIsOpen: false, selectedWorkshopId: '' });
                  }}
                >
                  {
                    this.props.service === SERVICE_WORKSHOP ? (
                      <div style={{ marginTop: 8, fontSize: 14 }}>
                        {t('csSetWorkshopToCurrent', { ns: 'ChainSettingsView' })}
                        {this.props.currentWorkshopName ? (': ' + this.props.currentWorkshopName) : ''}
                      </div>
                    ) : (
                      <select
                        value={this.state.selectedWorkshopId}
                        onChange={(e) => this.setState({ selectedWorkshopId: e.target.value })}
                        style={{ width: '100%', padding: 8, fontSize: 14, marginTop: 8 }}
                      >
                        <option value="">{t('csDefaultWorkshop', { ns: 'ChainSettingsView' })}</option>
                        {(this.props.chainMemberships || []).filter(function (m) {
                          return m.has_chain_care_service_deal;
                        }).map(function (m) {
                          var wsId = m.workshop && m.workshop.id ? m.workshop.id : m.workshop;
                          var wsName = m.workshop && m.workshop.name ? m.workshop.name : ('Korjaamo #' + wsId);
                          return <option key={m.id} value={wsId}>{wsName}</option>;
                        })}
                      </select>
                    )
                  }
                </CBPromptModal>
              )
            }

          </React.Fragment>
        )}
      </CBMediaQuery>
    );
  }
}

const mobileBadgeStyles = {
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
    borderRadius: 12,
    padding: '3px 10px',
    fontSize: 12,
    color: '#FFFFFF',
  },
};

const styles = {
  default: {
    infoIcon: {
      height: 32,
      width: 32,
    },
    alignCenter: {
      textAlign: 'center',
    },
    vehicleRow: {
      height: '60px',
      width: '100%',
      marginBottom: 2,

    },
    imgPlaceholder: {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      width: 100,
      height: 60,
    },
    vehicleImageColumn: {
      width: 100,
      padding: 8,
      cursor: 'pointer',
      borderBottom: '1px solid rgba(255, 255, 255, .3)',
    },
    tableValueTd: {
      fontFamily: 'TitilliumWeb-Light',
      fontSize: 18,
      color: '#FFFFFF',
      padding: 8,
      cursor: 'pointer',
      borderBottom: '1px solid rgba(255, 255, 255, .3)',
    },
    optionsIcon: {
      cursor: 'pointer',
    },
    tableRegNumTd: {
      fontFamily: 'TitilliumWeb-Bold',
      fontSize: 18,
      color: '#FFFFFF',
      //position: 'sticky',
      left: 0,
      padding: '8px 16px 8px 16px',
      borderBottom: '1px solid rgba(255, 255, 255, .3)',
    },
    tableOptionsTd: {
      right: 0,
      padding: '0 16px 0 16px',
      zIndex: 0,
    },
  },
  medium: {
  },
  small: {
  },
};

export default translate('VehicleListItem')(withRouter(VehicleListItem));
